if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();

        this.quantityInput = this.querySelector('.quantity__input');
        this.locationData = this.querySelector('[location-data]');
        if (this.locationData != undefined) {
          this.locationDataJSON = JSON.parse(this.locationData.textContent);
          this.inventoryDisplay = document.querySelector('.product__inventory');
          this.locationsContainer = document.querySelector('.product__inventory-locations');
          this.stockSVG = this.inventoryDisplay.querySelector('.svg-wrapper').innerHTML;
          this.currentVariantId = this.getSelectedVariant(this);
          if (this.currentVariantId == undefined && this.querySelector('.product-variant-id') != undefined) {
            this.currentVariantId = {id: this.querySelector('.product-variant-id').value};
          }
          this.checkAvailableLocations(this.currentVariantId);
        }
      }

      checkAvailableLocations(variant) {
        if (this.locationDataJSON != undefined) {
          if (!variant) {
            console.log("No variant")
            this.locationsContainer.style.display = "none";
            this.inventoryDisplay.style.display = "flex";
          } else {
            this.locationsContainer.style.display = "block";
            this.locationsContainer.innerHTML = "";
            for (const [key, value] of Object.entries(this.locationDataJSON.variants[variant.id].available_locations)) {
              if (parseInt(value) <= 0) continue;
              var color = "color: grey";
              var message = this.locationDataJSON.outofstock.replaceAll('[inventory]', value);
              if (parseInt(value) >= parseInt(this.locationDataJSON.threshold)) {
                color = "color: rgb(62, 214, 96)";
                message = this.locationDataJSON.instock.replaceAll('[inventory]', value);
              } else if (parseInt(value) > 0) {
                color = "color: rgb(238, 148, 65)";
                message = this.locationDataJSON.lowstock.replaceAll('[inventory]', value);
              }
              this.locationsContainer.innerHTML += `<div class="plug__inventory-location"><span class="svg-wrapper" style="${color}">${this.stockSVG}</span><p>${key}:</p>${message}</div>`;
            }
            if (Object.keys(this.locationDataJSON.variants[variant.id].available_locations).length > 0) {
              this.inventoryDisplay.style.display = "none";
            } else {
              this.inventoryDisplay.style.display = "flex";
            }
          }
        }
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);
          console.log(variant)
          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          if (!variant) {
            this.setUnavailable();
            return;
          }
          if (this.locationData != undefined) {
            this.checkAvailableLocations(variant);
          }
          this.updateMedia(html, variant?.featured_media?.id);

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };

          updateSourceFromDestination('price');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

          this.productForm?.toggleSubmitButton(
            html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
            window.variantStrings.soldOut
          );

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        );

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;

        const mediaGallerySource = this.querySelector('media-gallery ul');
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        const refreshSourceData = () => {
          if (this.hasAttribute('data-zoom-on-hover')) enableZoomOnHover(2);
          const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
          const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }])
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll('li[data-media-id]')
          );
          const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // refresh
          if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
            const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

            if (sourceData && sourceData.index !== destinationIndex) {
              mediaGallerySource.insertBefore(
                sourceData.item,
                mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
              );

              // refresh source now that it has been modified
              [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
            }
          });
        }

        // set featured media as active in the media gallery
        this.querySelector(`media-gallery`)?.setActiveMedia?.(
          `${this.dataset.section}-${variantFeaturedMediaId}`,
          true
        );

        // update media modal
        const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
        const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
        if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden'));
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}

if (!customElements.get('plug-calculator')) {
  customElements.define('plug-calculator', class ProductInfo extends HTMLElement {
    constructor() {
      super();
      this.inputs_container = this.querySelector('.plug-calculator__inputs')
      this.submit_button = this.querySelector('.plug-calculator__submit');
      this.result_container =  this.querySelector('.plug-calculator__result');
      this.form = this.querySelector('form');
      this.currency = this.form.getAttribute('currency_symbol');
      this.product_form = {};
      this.product_form.form = document.querySelector(`#${this.form.getAttribute('product_form')}`);
      this.product_form.quantity = document.querySelector(`[name="quantity"][form="${this.form.getAttribute('product_form')}"]`)
      this.input_select = this.querySelector('select');
      this.inputs = this.inputs_container.querySelectorAll('input');
      this.method = this.form.getAttribute('calc_type');
      this.waste_element = this.querySelector('[name="waste"]');
      
      this.listeners();
    }
    listeners() {
      this.submit_button.addEventListener('click', this.submit.bind(this));
      this.input_select.addEventListener('input', this.toggle_input.bind(this));
      this.waste_element.addEventListener('input', this.submit.bind(this));
      this.inputs.forEach((input) => {
        input.addEventListener('input', this.checkInputs.bind(this));
      })
    }
    checkInputs() {
      console.log(this.method)
      switch(this.method) {
        case 'lxw':
          let length = Array.from(this.inputs).find(input => input.getAttribute('name').includes("length")).value;
          let width = Array.from(this.inputs).find(input => input.getAttribute('name').includes("width")).value;
          let error = [];
          if (length == "") {
            error.push("length");
          }
          if (width == "") {
            error.push("width");
          }
          console.log("Check LxW inputs")
          console.log(length);
          console.log(width);
          console.log(error)
          if (error.length > 0) {
            this.submit_button.setAttribute('disabled', true);
            this.submit_button.classList.remove('active');
          } else {
            this.submit_button.removeAttribute('disabled');
            this.submit_button.classList.add('active');
          }
          return
        case 'sqft':
          let sqft = Array.from(this.inputs).find(input => input.getAttribute('name').includes("sqft")).value;
          console.log("Check sqft input")
          if (sqft == "") {
            this.submit_button.setAttribute('disabled', true);
            this.submit_button.classList.remove('active');
          } else {
            this.submit_button.removeAttribute('disabled');
            this.submit_button.classList.add('active');
          }
          return
      }
    }
    toggle_input() {
      let value = this.input_select.value;
      this.form.setAttribute('calc_type', value);
      this.method = this.form.getAttribute('calc_type');
      this.checkInputs();
    }
    submit() {
      this.submit_button.classList.add('calculating');
      let results = this.calculate();
      setTimeout(()=>{
        this.displayresult(results);
        this.submit_button.classList.remove('calculating');
      }, 200)
     
      console.log(results);
    }
    calculate() {
      let waste = this.querySelector('[name="waste"]').checked;
      let result = {};
      let coverage = parseFloat(this.inputs_container.getAttribute('coverage'));
      let price = parseFloat(this.inputs_container.getAttribute('price'));
      switch(this.method) {
        case 'lxw':
          let error = [];
          console.log("compute length and width")
          let length = Array.from(this.inputs).find(input => input.getAttribute('name').includes("length")).value;
          let width = Array.from(this.inputs).find(input => input.getAttribute('name').includes("width")).value;
          if (length == "") {
            error.push("length");
          }
          if (width == "") {
            error.push("width");
          }
          if (error.length > 0) {
            result.error = error;
            return;
          }
          result.coverage = coverage
          result.length = length;
          result.width = width;
          result.area = parseFloat(length) * parseFloat(width);
          if (waste) {
            result.area = result.area * 1.1;
          }
          result.quantity = Math.ceil(result.area / coverage);
          result.price = parseFloat((result.quantity * price)/100.00);
          return result;
        case 'sqft':
          result.coverage = coverage;
          result.area = Array.from(this.inputs).find(input => input.getAttribute('name').includes("sqft")).value;
          if (waste) {
            result.area = result.area * 1.1;
          }
          result.quantity = Math.ceil(result.area / coverage);
          result.price = parseFloat((result.quantity * price)/100.00);
          return result;
      }
    }
    displayresult(results) {
      let error = false;
      if (results == undefined || results == {}) {
        error = true;
      } else {
        if ( results.error != undefined) {
          error = true;
        }
      }
       console.log(error)
      if (!error) {
        let price_container = this.result_container.querySelector('.plug-calculator__result-price .highlight span');
        let quantity_container = this.result_container.querySelector('.plug-calculator__result-quantity span');
        let area_container = this.result_container.querySelector('.plug-calculator__result-quantity .area');
        // price_container.innerHTML = "Price: " + this.currency.replaceAll('{{amount}}', results.price.toFixed(2));
        // quantity_container.innerHTML = "Quantity: " + results.quantity;
         quantity_container.innerHTML = results.quantity;
        price_container.innerHTML = this.currency.replaceAll('{{amount}}', results.price.toFixed(2));
        area_container.innerHTML = (results.coverage * results.quantity).toFixed(2);
        this.product_form.quantity.value = results.quantity;
      } else {
        // display error
      }
    }
  })
}